import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    DialogButtonComponent,
    DialogButtonsComponent,
    RadioButtonComponent,
    RadioGroupComponent,
} from '@interacta-shared/ui';
import { RelatedLinkedBy } from '@modules/communities/models/related-item/related-item.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-relations-dialog-field',
    templateUrl: './relations-dialog-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        DialogButtonsComponent,
        DialogButtonComponent,
        RadioGroupComponent,
        RadioButtonComponent,
        TranslatePipe,
    ],
})
export class RelationsDialogFieldComponent {
    inverseLink = input.required<RelatedLinkedBy>();

    back = output<void>();
    selectLink = output<{ link: RelatedLinkedBy }>();

    readonly mappedInverseLink = computed<RelatedLinkedBy[]>(() =>
        (this.inverseLink().linkedBy.postLinkFieldDefinitions ?? []).map(
            (field) => ({
                ...this.inverseLink(),
                linkedBy: {
                    ...this.inverseLink().linkedBy,
                    postLinkFieldDefinitions: [field],
                },
            }),
        ),
    );

    selectedLink?: RelatedLinkedBy;
}
